const firebase = {
  appId: '1:1078047854127:web:26df0789479d402455c0da',
  apiKey: 'AIzaSyC0DiroJfoMl0mJFpDyRXu_Lw5zbSaDsOI',
  projectId: 'ats-all-projects'
}

const environments = {
  development: {
    isProduction: false,
    api: {
      v2: 'https://staging.api.solides.jobs/v2',
      v3: 'https://apigwstg.solides.com.br/jobs/v3',
      applicants: 'https://apigwstg.solides.com.br/applicants-v2/jobs/v4'
    },
    google_analytics: 'GTM-5ND9KNF',
    host_profile: 'https://perfil.vagas.staging.solides.com.br',
    host_portal: 'https://vagas.staging.solides.com.br',
    host_auth: 'https://auth.vagas.staging.solides.com.br',
    hotjar_id: '3311665',
    firebase
  },
  production: {
    isProduction: true,
    api: {
      v2: 'https://api.solides.jobs/v2',
      v3: 'https://apigw.solides.com.br/jobs/v3',
      applicants: 'https://apigw.solides.com.br/applicants-v2/jobs/v4'
    },
    google_analytics: 'GTM-NZVFQCV',
    host_profile: 'https://perfil.vagas.solides.com.br',
    host_portal: 'https://vagas.solides.com.br',
    host_auth: 'https://auth.vagas.solides.com.br',
    hotjar_id: '1323765',
    firebase
  }
}

type Environment = keyof typeof environments

const key = process?.env?.ENV || 'production'

export default environments[key as Environment]
